import { render } from "./VNestedElements.vue?vue&type=template&id=4adc15be"
import script from "./VNestedElements.vue?vue&type=script&lang=js"
export * from "./VNestedElements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__